<div class="notification-center-item">
  <hr />
  <div class="notification-center-item-header">
    <span>
      <svg-icon icon="icon_download" />
      {{ item().title }}</span
    >
  </div>

  <p>{{ item().message }}</p>

  @if (item().validUntil; as vU) {
    <p i18n="@@menu.notifications.validUntil">Your download is available until {{ vU | date }}</p>
  }

  @if (item().downloadLink; as dlLink) {
    <p>
      <a [href]="dlLink" mat-button color="accent" target="_blank"
        ><svg-icon icon="icon_download" /><span i18n="@@menu.notifications.download">Download</span></a
      >
    </p>
  }

  @if (item().productLink; as pLink) {
    <p>
      <a [routerLink]="pLink" mat-button color="accent" i18n="@@menu.notifications.product-link">Go to product</a>
    </p>
  }

  <time>{{ relaiveCreationTime() }}</time>
</div>
